export const columnsVariant: any =(t:any)=> [
    {
        title: t('Image'),
        dataIndex: 'image',
        align: 'left',
        width: '90px',
    },
    {
        title: t('Variant Title'),
        dataIndex: 'variant_title',
        align: 'left',
        width: '180px',
    },
    {
        title: t('SKU'),
        dataIndex: 'sku',
        align: 'left',
        width: '220px',
    },
    {
        title: t('Barcode'),
        dataIndex: 'barcode',
        align: 'left',
        width: '120px',
    },
    {
        title: t('Price'),
        dataIndex: 'price',
        align: 'left',
        width: '80px',
    },
    {
        title: t('ASIN'),
        dataIndex: 'asin',
        align: 'left',
        width: '140px',
    }, {
        title: t('Fulfilment'),
        dataIndex: 'fulfilment',
        align: 'left',
        width: '95px',
    },
    {
        title: t('Inventory'),
        dataIndex: 'quantity',
        align: 'left',
        width: ' 100px',
    },
    {
        title: t('Amazon Status'),
        dataIndex: 'status',
        align: 'left',
        width: '140px',
    },
    {
        title: t('Activity'),
        dataIndex: 'activity',
        align: 'left',
        width: '140px',
    },

    {
        title: t('Feed'),
        dataIndex: 'feed',
        align: 'left',
        width: '70px',
    },
];